import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ShipmentCreditClaimsDetailModule } from './shipment-credit-claims-detail/shipment-credit-claims-detail.module'
import { ShipmentCreditClaimsHistoryModule } from './shipment-credit-claims-history/shipment-credit-claims-history.module'
import { ShipmentCreditClaimsModule } from './shipment-credit-claims/shipment-credit-claims.module'

@NgModule({
  imports: [
    CommonModule,
    ShipmentCreditClaimsModule,
    ShipmentCreditClaimsHistoryModule,
    ShipmentCreditClaimsDetailModule
  ]
})
export class ShipmentCreditClaimModule {}
